module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/284.c391ee41.png";